/**
 * Fetches plain-text content from a given URL as string.
 * Supports .txt, .log, .csv, .json, .xml, .yaml, etc.
 */
export const fetchTextFile = async (url: string): Promise<string> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch text file: ${response.statusText}`);
  }

  const contentType = response.headers.get("Content-Type") || "";
  if (!contentType.includes("text") && !contentType.includes("json")) {
    console.warn(`Unexpected content type: ${contentType}`);
  }

  return await response.text();
};
